import { Button } from '@foam/buoy/src/components/Button/Button';
import { Icon } from '@foam/buoy/src/components/Icon/Icon';

type CreateMediaKitButtonType = {
  onClick: () => void;
  trackId: string;
  isDisabled?: boolean;
  hideIcon?: boolean;
  className?: string;
};
export const CreateMediaKitButton: React.FC<CreateMediaKitButtonType> = ({
  onClick,
  trackId,
  isDisabled = false,
  hideIcon = false,
  className,
}) => {
  return (
    <Button
      variant="primary"
      size="lg"
      disabled={isDisabled}
      onClick={onClick}
      data-testid="create-media-kit-button"
      track-id={trackId}
      className={className}
    >
      {!hideIcon && <Icon name="Plus" className="size-4" />}
      Create Media Kit
    </Button>
  );
};
